import { render, staticRenderFns } from "./PhoneComponent.vue?vue&type=template&id=43b31cda"
import script from "./PhoneComponent.vue?vue&type=script&lang=js"
export * from "./PhoneComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports